export enum BookingType {
    EducationCourseRenewal = 'EDUCATION_COURSE_RENEWAL',
    TrainingCourseRenewal = 'TRAINING_COURSE_RENEWAL',
    Exam = 'EXAM',
}
